import Logo from '@assets/images/logo.png';
import { Drawer, Menu, type MenuProps } from 'antd';
import { useEffect, useState } from 'react';
import { RiMenuLine } from 'react-icons/ri';
import { PiBooks, PiUserBold } from 'react-icons/pi';
import { RiAppsLine, RiHome5Line } from 'react-icons/ri';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './index.module.scss';
import { IoLogOutOutline } from 'react-icons/io5';
import { BiWorld } from 'react-icons/bi';
import { MdChildCare } from 'react-icons/md';

type MenuItem = Required<MenuProps>['items'][number];

const MobileHeader = () => {
  const [open, setOpen] = useState(false);
  const { pathname, hash } = useLocation();
  const navigate = useNavigate();
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleSelectKey = (item: string) => {
    navigate(item);
  };

  const items: MenuItem[] = [
    {
      key: '/',
      icon: <RiHome5Line size={18} />,
      label: 'Home',
    },
    {
      key: '/dashboard',
      icon: <RiAppsLine size={18} />,
      label: 'Dashboard',
      className:
        `${pathname}${hash}` === '/dashboard' ? 'ant-menu-item-selected' : '',
    },
    {
      key: '/dashboard/library',
      icon: <PiBooks size={18} />,
      label: 'Our Library',
      className:
        `${pathname}${hash}` === '/dashboard/library'
          ? 'ant-menu-item-selected'
          : '',
    },
    {
      key: '/dashboard/tadatoonLibrary',
      icon: <BiWorld size={18} />,
      label: 'Tadatoon Library',
      className:
        `${pathname}${hash}` === '/dashboard/tadatoonLibrary'
          ? 'ant-menu-item-selected'
          : '',
    },
    {
      key: '/dashboard/profile',
      icon: <PiUserBold size={18} />,
      label: 'Profile',
      className:
        `${pathname}${hash}` === '/dashboard/profile'
          ? 'ant-menu-item-selected'
          : '',
    },
    {
      key: '/dashboard/my-child',
      icon: <MdChildCare size={18} />,
      label: 'My Children',
      className:
        `${pathname}${hash}` === '/dashboard/my-child'
          ? 'ant-menu-item-selected'
          : '',
    },
    {
      key: '/logout',
      icon: <IoLogOutOutline size={18} />,
      label: 'Logout',
      onClick: () => {
        localStorage.clear();
        // Dispatch custom event to notify store
        window.dispatchEvent(new Event('authStateCleared'));
        navigate('/');
      },
    },
  ];
  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <div>
      <div className={styles['header']}>
        <img src={Logo} alt="Tadatoon Logo" />
        <RiMenuLine color='#000' size={35} onClick={showDrawer} />
      </div>

      <Drawer
        className={styles['drawer']}
        title={
          <>
            <img src={Logo} alt="Tadatoon Logo" width={120} height={43} />
          </>
        }
        closeIcon={false}
        placement="right"
        onClose={onClose}
        open={open}
        width={230}>
        <Menu
          theme="dark"
          defaultSelectedKeys={['1']}
          onSelect={(event) => handleSelectKey(event.key)}
          mode="inline"
          items={items}
        />
      </Drawer>
    </div>
  );
};

export default MobileHeader;
